import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { getErrorCode } from '@core/utils/get-error-code';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FormValidator } from '@validators/linked-forms-no-all-options-validation';
import { sentry } from 'sentry';
import { SegmentService } from '../services/segment.service';
import { DialogSegmentsMapper } from './dialog-segments.mapper';
import { TabSettingsComponent } from './tabs/settings/tab-settings.component';
var DialogSegmentsComponent = /** @class */ (function () {
    function DialogSegmentsComponent(dialogData, matDialogRef, authenticationService, customMessageService, progressBar, segmentService, formBuilder) {
        this.dialogData = dialogData;
        this.matDialogRef = matDialogRef;
        this.authenticationService = authenticationService;
        this.customMessageService = customMessageService;
        this.progressBar = progressBar;
        this.segmentService = segmentService;
        this.formBuilder = formBuilder;
        this.isSaving = false;
        this.isDuplicatedForm = false;
        this.hasEditGroupPermission = false;
        this.selectedTabIndex = 0;
        this.segment = this.dialogData.segment;
        this.isViewMode = this.dialogData.isViewMode;
        this.hasEditGroupPermission = this.authenticationService.hasPermission('groups-edit');
    }
    DialogSegmentsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.generalForm = DialogSegmentsMapper.toGeneralForm(this.segment, this.formBuilder);
        this.maintenanceTypesForm = DialogSegmentsMapper.toMaintenanceTypesForm(this.segment, this.formBuilder);
        this.segmentMaintenanceFormsArray = DialogSegmentsMapper.toSegmentMaintenanceFormsArray(this.segment, this.formBuilder);
        this.defaultValues = {
            general: this.generalForm.value.name,
            maintenanceForms: this.segmentMaintenanceFormsArray.value
        };
        this.segmentMaintenanceFormsArray.setValidators(FormValidator.validateForm);
        this.segmentMaintenanceFormsArray.valueChanges.subscribe(function () {
            _this.isDuplicatedForm = _this.segmentMaintenanceFormsArray.controls.some(function (formGroup) { return formGroup.get('form').hasError('formDuplicated'); });
        });
        this.matDialogRef.disableClose = true;
        this.matDialogRef.backdropClick().subscribe(function () {
            _this.matDialogRef.close();
        });
        if (this.isViewMode) {
            this.generalForm.disable();
        }
    };
    DialogSegmentsComponent.prototype.onLinkMaintenanceTypesToSegmentChange = function (value) {
        this.noMaintenancesSelected = value;
    };
    DialogSegmentsComponent.prototype.saveSegment = function (_a) {
        var closeDialog = _a.closeDialog;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var savedSuccessfully, input, _b, err_1, code;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.isSaving = true;
                        this.progressBar.show();
                        savedSuccessfully = false;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        input = DialogSegmentsMapper.toSaveSegmentInput({
                            segment: this.segment,
                            generalForm: this.generalForm,
                            settingsTab: this.settingsTab,
                            segmentsIds: this.segmentsSelection,
                            maintenanceTypesForm: this.maintenanceTypesForm,
                            segmentMaintenanceFormsArray: this.segmentMaintenanceFormsArray,
                        });
                        _b = this;
                        return [4 /*yield*/, this.segmentService.save(this.segment.id, input)];
                    case 2:
                        _b.segment = _c.sent();
                        this.customMessageService.success("SEGMENTS.SUCCESS_MESSAGE");
                        savedSuccessfully = true;
                        if (closeDialog) {
                            this.matDialogRef.close(true);
                            this.customMessageService.success('SEGMENTS.SUCCESS_MESSAGE');
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _c.sent();
                        code = getErrorCode(err_1);
                        if (code === 'segment_name_duplicated') {
                            this.generalForm.get('name').setErrors({
                                'segment_name_duplicated': true
                            });
                            return [2 /*return*/];
                        }
                        if (code === 'segment_maintenance_type_form_duplicated') {
                            this.generalForm.get('name').setErrors({
                                'formDuplicated': true
                            });
                            return [2 /*return*/];
                        }
                        this.customMessageService.error('SEGMENTS.ERROR_MESSAGE');
                        sentry.captureException(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.progressBar.hide();
                        this.isSaving = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/, savedSuccessfully];
                }
            });
        });
    };
    DialogSegmentsComponent.prototype.archiveOrUnarchiveSegment = function (archived) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.segment.archived = archived;
                        return [4 /*yield*/, this.saveSegment({ closeDialog: true })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogSegmentsComponent.prototype.continue = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var savedSuccessfully;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.selectedTabIndex !== 0) {
                            this.selectedTabIndex++;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.saveSegment({ closeDialog: false })];
                    case 1:
                        savedSuccessfully = _a.sent();
                        if (savedSuccessfully) {
                            this.selectedTabIndex = 1;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return DialogSegmentsComponent;
}());
export { DialogSegmentsComponent };
